import { FunctionComponent, ReactNode } from 'react';

import { BreadcrumbItem, PageBreadcrumbs } from '~/client/components/shared/PageBreadcrumbs';

import { HeaderRoot, HeaderContent } from './PageHeader.styled';

interface Props {
  breadcrumbLinks?: BreadcrumbItem[];
  children: ReactNode;
}

export const PageHeader: FunctionComponent<Props> = ({ breadcrumbLinks, children }) => (
  <HeaderRoot>
    <HeaderContent>
      {!!breadcrumbLinks?.length && <PageBreadcrumbs links={breadcrumbLinks} />}
      {children}
    </HeaderContent>
  </HeaderRoot>
);
